import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { IndoorAmateurBootstrapComponent } from './worldarchery_indoor-world-series-amateur-ranking/indoor-amateur-bootstrap/indoor-amateur-bootstrap.component';
import { IndoorCalendarBootstrapComponent } from './worldarchery_indoor-world-series-calendar/indoor-calendar-bootstrap/indoor-calendar-bootstrap.component';
import { IndoorEliteBootstrapComponent } from './worldarchery_indoor-world-series-elite-ranking/indoor-elite-bootstrap/indoor-elite-bootstrap.component';
import { IndoorTeamsBootstrapComponent } from './worldarchery_indoor-world-series-teams/indoor-teams-bootstrap/indoor-teams-bootstrap.component';

const routes: Routes = [
  { path: '', component: AppComponent,
    children: [
      {path:'', redirectTo:'calendar', pathMatch: 'full'},
      {
        path: 'calendar',
        loadChildren:
          () => import('./worldarchery_indoor-world-series-calendar/indoor-world-series-calendar.module').then(m => m.IndoorWorldSeriesCalendarModule)
      },
      {
        path: 'open-ranking',
        loadChildren:
          () => import('./worldarchery_indoor-world-series-amateur-ranking/indoor-world-series-amateur-ranking.module').then(m => m.IndoorWorldSeriesAmateurRankingModule)
      },
      {
        path: 'elite-ranking',
        loadChildren:
          () => import('./worldarchery_indoor-world-series-elite-ranking/indoor-world-series-elite-ranking.module').then(m => m.IndoorWorldSeriesEliteRankingModule)
      },
      {
        path: 'team-ranking',
        loadChildren:
          () => import('./worldarchery_indoor-world-series-teams/indoor-world-series-teams.module').then(m => m.IndoorWorldSeriesTeamsModule),
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
